/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@-moz-document url-prefix(){input[type=file].form-control{height:auto!important;padding:0}}.ui-upload-button[_ngcontent-%COMP%]{padding:0 8px;margin:8px 0 0 8px}.ui-cancel-button[_ngcontent-%COMP%]{margin-top:6px}"];
export { styles as styles };
